
<template>
  <v-container fluid>
    <v-layout >
      <v-flex xs12 md12>
        <div class="login-b2b-container">
          <div class="login-box">
            <div class="b2b-login-header-logo">
              <img
                :src="
                  'https://detailss3web.s3.amazonaws.com/images/logo/' +
                  clientName +
                  'logo'
                "
                alt=""
                srcset=""
              />
            </div>
            <v-card class="dt-modal login-card">
              <div class="dt-modal--header">
                <h1>Sign in</h1>
                <h3>Enter your details below</h3>
              </div>

              <div class="dt-modal--body">
                <div class="form-group">
                  <TextField
                    :id="'username'"
                    required
                    :value="loginUser.username"
                    v-bind="textFieldConfig"
                    :placeholder="'Username'"
                    @valuechanged="onTextFieldValueChange"
                    @validated="onValidation"
                  ></TextField>
                  <!-- <span style="margin-left: 5px; color: #696b6c;font-size: 13px;"
                    >Is this your first log in?</span
                  > -->
                  <a
                    style="width: 112px; margin: 5px"
                    @click.stop="onClickResetUserName"
                    href="javascript:void()"
                    >Get your username</a
                  >
                  <TextField
                    :id="'password'"
                    required
                    password
                    v-bind="textFieldConfig"
                    :value="loginUser.password"
                    :placeholder="'Password'"
                    @valuechanged="onTextFieldValueChange"
                    @validated="onValidation"
                  ></TextField>
                </div>
              </div>
              <a @click.stop="onClickReset" href="javascript:void()"
                >Set your password</a
              >
              <div class="dt-modal--options">
                <button
                  class="dt-button v1 s1"
                  :class="{ disabled: !isFormValid }"
                  :disabled="!isFormValid"
                  @click.stop="login"
                >
                  Login
                </button>
              </div>
            </v-card>
          </div>
          <div class="b2b-login-footer-logo">
            <a target="_blank" href="https://www.detailsdetails.eu/">
              <img :src="'./static/icons/b2b/share-logo.png'" alt="" srcset=""
            /></a>

            <!-- <div>
              by
              <a target="_blank" href="https://www.detailsdetails.eu/">
                <img
                  :src="'./static/images/details_logo_White.png'"
                  alt=""
                  srcset=""
              /></a>
            </div> -->
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { clientName } from "../../modules/b2b/services/http-client.js";
import TextField from "@plugins/text-field/text-field";
import * as ActionTypes from "../../modules/b2b/store/types.js";
import { B2BStoreNamespace as storeNS } from "../../modules/b2b/store/index";
import { mapGetters, mapActions, mapMutations } from "vuex";
import ResetPasswordForm from "./reset-password-form.vue";
import ModalContainer from "@dtplugins/modal/modal-container";
import { AuthService } from "../../modules/b2b/services/auth.service";
export default {
  name: "B2BLoginComponent",
  components: {
    TextField,
    ResetPasswordForm,
    ModalContainer,
  },
  data: function () {
    return {
      show1: false,
      dialog: false,
      isModalValid: false,
      errors: [],
      user: {
        username: "",
        password: "",
      },

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      validationResult: {},
    };
  },
  computed: {
    clientName() {
      return clientName;
    },
    ...mapGetters(storeNS, {
      loginUser: "loginUser",
    }),
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.B2B_LOGIN]: ActionTypes.B2B_LOGIN,
    }),
    ...mapMutations(storeNS, {
      [ActionTypes.B2B_SET_LOGIN_USER]: ActionTypes.B2B_SET_LOGIN_USER,
    }),
    onTextFieldValueChange: function (key, value) {
      this[ActionTypes.B2B_SET_LOGIN_USER]({
        [key]: value,
      });
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    login: function () {
      this[ActionTypes.B2B_LOGIN]();
    },
    onClickResetUserName: function () {
      AuthService.getResetUserNameUrl().then((res) => {
        window.open(res.data.recover_un_url, "_self");
      });
    },
    onClickReset: function () {
      AuthService.getResetPasswordUrl().then((res) => {
        window.open(res.data.recover_pw_url, "_self");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0px;
}
.dt-input-box--container {
  --tf-webkit-box-shadow: none !important;
}
.dt-input-box--container .dt-input-box .input-container {
  width: 95% !important;
}
.dt-input-box--container .dt-input-box .validation-status {
  margin-right: 0px;
  margin-top: 10px;
}

.login-b2b-container {
  -webkit-box-flex: 1;
  flex: auto;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #424242;
  .login-box {
    flex: 1;
    align-content: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    .b2b-login-header-logo {
      padding-left: 5px;
      display: flex;
      flex-direction: column;
      align-self: center;
      img {
        display: flex;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
        width: 100%;
        max-height: 120px;
      }
    }
    .login-card {
      margin-top: 25px;
      width: 100%;
      max-width: 450px;
      min-width: 350px;
      max-height: 430px;
      box-shadow: none;
      background-color: rgb(250, 250, 250);
      border-radius: 5%;

      a {
        height: 18px;
        width: fit-content;
        color: #0087ff;
        font-family: Roboto;
        font-size: 13px;
        line-height: 18px;
        border-bottom: 1px solid;
        margin: 10px;
      }
      h1,
      h3 {
        font-weight: 500;
      }
      .dt-modal--header {
        color: #424242;
        text-transform: none;
        font-family: Roboto;
        font-weight: 500;
        line-height: 40px;
        padding-left: 10px;
      }
      .dt-modal--body {
        padding: 0 5px;
        margin-bottom: 5px;
      }
      .company-logo {
        width: 100%;
      }

      .form-group {
        display: flex;
        flex-direction: column;

        .dt-input-box {
          flex: 1;
          margin: 10px;
          margin-left: 0px;
          background: none !important;
        }

        .group-input {
          margin-top: 25px;
          margin-bottom: 10px;
        }
      }
      .dt-modal--options {
        margin-top: 10px;
        display: flex;
        width: 170px;
        button {
          height: 40px;
          background-color: #50e890;
          border: 0px;
          color: #282828;
        }
      }
    }
  }

  .b2b-login-footer-logo {
    display: flex;

    margin-top: auto;
    padding-right: 30px;
    padding-bottom: 30px;
    align-self: flex-end;

    img {
      display: flex;
      width: 100px;
      max-width: 100px;
      height: 50;
      cursor: pointer;
    }
  }
}

@media only screen and (max-width: 992px) {
  .login-b2b-container {
    background-color: #424242;
    .login-box {
      .b2b-login-header-logo {
        display: flex;
        flex-direction: column;
        align-self: center;
        padding-bottom: 50px;
        padding-left: 5px;
        img {
          display: flex;
          max-width: 100%;
          height: auto;
          margin: 0 auto;
        }
      }
      .login-card {
        background: #424242;
        color: white;
        --text-2: white;
        --sprt-2: white;
        --sprt-9: #333333;
        --text-5: white;

        .dt-modal--header {
          color: rgb(250, 250, 250);
        }
      }
    }
  }

  .dt-input-box--label {
    color: rgb(250, 250, 250) !important;
  }
  input {
    color: rgb(250, 250, 250);
  }
}

@media only screen and (max-width: 600px) {
  .login-b2b-container {
    .login-box {
      .b2b-login-header-logo {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        padding-left: 10px;
        // img {
        //   width: 250px;
        //   max-width: 250px;
        // }
      }
      .login-card {
        margin: 0 !important;
      }
    }
    .b2b-login-footer-logo {
      font-size: 15px;
      line-height: 30px;
      img {
        width: 100px;
        max-width: 100px;
        height: 50px;
      }
    }
  }
}
</style>
